(ns frontend.ui.component.lp-portal.report.component.multi-chart.controller
  (:require
   [common.util :as cu]
   [frontend.ui.component.chart.utils :as chart-utils]
   [frontend.ui.page.lp-portal.report.util :as report-utils]
   [frontend.ui.style.theme.core :as theme]
   ["highcharts" :as highcharts]))


(defn config->editable-data
  [config]
  {:columns (:series-categories config)
   :series (:series config)
   :y-axis-configs (:y-axis-configs config)})

(defn editable-data->raw-data
  [edited-data]
  (merge edited-data
         {:series-categories (:columns edited-data)}))

(defn multi-chart-ctl
  [chart-data _report-data]
  (let [y-axis-configs (->>
                        (:y-axis-configs chart-data)
                        (mapv
                         (fn [y-axis]
                           (let [title (:y-axis-title y-axis)
                                 title-color (:y-axis-title-color y-axis)
                                 y-axis-side (:y-axis-side y-axis)
                                 y-axis-id (:y-axis-id y-axis) ;;NOTE id must start with 0
                                 y-axis-multiplier (:y-axis-multiplier y-axis)
                                 y-axis-decimals (:y-axis-decimals y-axis)]
                             {:title          {:text     title
                                               :align    "high"
                                               :offset   0
                                               :rotation 0
                                               :x        (cond (and (= y-axis-side "right")
                                                                    (theme/innovestor-theme?))
                                                               13
                                                               (= (theme/get-theme) :theme.lp-portal/lifeline)
                                                               30
                                                               :else 0)
                                               :y        (if (= (theme/get-theme) :theme.lp-portal/lifeline)
                                                          -17
                                                          -10)
                                               :style    {:color title-color}}
                              :lineWidth      1
                              :labels         {:formatter (fn [label]
                                                            (report-utils/->float-x-decimals
                                                             (/ (.-value label) y-axis-multiplier)
                                                             y-axis-decimals))}
                              :id             (dec y-axis-id)
                              :opposite       (case y-axis-side
                                                "right" true
                                                "left" false
                                                true)
                              :showEmpty      false
                              :lineColor      (theme/color [:lp-report :chart :y-axis :line])
                              :reversedStacks false}))))
        series (->>
                (:series chart-data)
                (filter :y-axis-id)
                (map-indexed
                 (fn [index series-item]
                   (let [name (:series-name series-item)
                         data (:data series-item)
                         graph-type (:graph-type series-item)
                         dotted-line? (= graph-type "dotted line")
                         y-axis-id (:y-axis-id series-item)
                         graph-index (:graph-index series-item)
                         color (:color-code series-item)
                         tooltip-decimals (:tooltip-decimals series-item)
                         datalabel-decimals (:label-decimals series-item)
                         datalabel-multiplier (:label-multiplier series-item)]
                     {:name         name
                      :type         (if dotted-line?
                                      "line"
                                      graph-type)
                      :yAxis        (dec y-axis-id)
                      :data         data
                      :stack        graph-index
                      :states       {:hover {:color (theme/color [:lp-report :chart :series-hover :bg])}}
                      :pointPadding 0.05
                      :dashStyle (when dotted-line? "Dot")
                      :color        (if (cu/blank-value? color)
                                      (theme/color [:lp-report :chart :multi-chart :ordered-default-colors
                                                    (keyword (str "color-" (inc index)))])
                                      color)
                      :dataLabels   {:enabled       (and (not (cu/blank-value? datalabel-decimals))
                                                         (not (cu/blank-value? datalabel-multiplier)))
                                     :formatter     (fn []
                                                      (this-as js-data-point
                                                               (let [suffix (case datalabel-multiplier
                                                                              1 ""
                                                                              1000 "k"
                                                                              1000000 "M"
                                                                              "")]
                                                                 (chart-utils/generic-label-formatter
                                                                  js-data-point
                                                                  datalabel-multiplier
                                                                  datalabel-decimals
                                                                  (if (and (= datalabel-multiplier
                                                                         (:y-axis-multiplier
                                                                          (nth (:y-axis-configs chart-data)
                                                                               (dec y-axis-id))))
                                                                           (not (theme/innovestor-theme?)))
                                                                    ""
                                                                    suffix)))))
                                     :align         "center"
                                     :verticalAlign (when-not (theme/innovestor-theme?) "top")
                                     :inside        (when (theme/innovestor-theme?) false)
                                     :style         {:fontSize    "0.8em"}}
                      :tooltip      {:pointFormatter (fn []
                                                       (this-as js-data-point
                                                                (chart-utils/float-tooltip-formatter-dynamic-decimals
                                                                 js-data-point
                                                                 ""
                                                                 1
                                                                 tooltip-decimals)))}})))
                (vec))
        series-categories (:series-categories chart-data)]
    {:chart       {:marginTop 40
                   :spacingRight 15}
     :plotOptions {:column {:stacking "normal"}}
     :tooltip     {:shared true}
     :legend      {:enabled       (> (count series) 1)
                   :squareSymbol  false
                   :symbolWidth   35
                   :symbolHeight  8
                   :symbolRadius  5
                   :verticalAlign "top"
                   :align         "left"
                   :floating      true
                   :padding       0
                   :y             -7
                   :itemStyle     {:fontWeight "normal"}
                  }
     :yAxis       y-axis-configs
     :xAxis       [{:categories series-categories
                    :lineColor  (theme/color [:lp-report :chart :x-axis :line])}]
     :series      series}))

(defn multi-chart-ctl-capman
  ([chart-data] (multi-chart-ctl-capman chart-data {}))
  ([chart-data {:keys [custom-annotation custom-linewidth] :as props}]
   (let [y-axis-configs (->>
                         (:y-axis-configs chart-data)
                         (mapv
                          (fn [y-axis]
                            (let [title (:y-axis-title y-axis)
                                  title-color (:y-axis-title-color y-axis)
                                  y-axis-side (:y-axis-side y-axis)
                                  y-axis-id (:y-axis-id y-axis) ;;NOTE id must start with 0
                                  y-axis-multiplier (:y-axis-multiplier y-axis)
                                  y-axis-decimals (:y-axis-decimals y-axis)
                                  stack-total-label? (:stack-total-label? props)]
                              {:title          {:text     title
                                                :align    "middle"
                                                :x 0
                                                :y 0
                                                :style    {:color title-color
                                                           :fontSize "0.8em"}}
                               :lineWidth      0
                               :labels         {:formatter (or (:custom-y-axis-formatter props)
                                                               (fn []
                                                                 (this-as js-data-point
                                                                          (.numberFormat highcharts
                                                                                         (/ (.-value js-data-point) y-axis-multiplier)
                                                                                         y-axis-decimals
                                                                                         "."
                                                                                         ","))))}
                               :stackLabels    (when stack-total-label?
                                                 {:enabled true
                                                  :style   {:fontWeight "bold"
                                                            :fontSize   "0.8em"
                                                            :color      "#000000"
                                                            :textOutline "none"}
                                                  :formatter
                                                  (fn []
                                                    (this-as ctx
                                                             (.numberFormat highcharts
                                                                            (/ (.-total ctx)
                                                                               y-axis-multiplier)
                                                                            (or (:stack-total-decimal-amount props)
                                                                                y-axis-decimals)
                                                                            "."
                                                                            ",")))})
                               :id             (dec y-axis-id)
                               :opposite       (case y-axis-side
                                                 "right" true
                                                 "left" false
                                                 true)
                               :showEmpty      false
                               :gridLineColor "#d7d7d7"
                               :lineColor      (theme/color [:lp-report :chart :y-axis :line])
                               :reversedStacks false}))))
         series (->>
                 (:series chart-data)
                 (filter :y-axis-id)
                 (map-indexed
                  (fn [index series-item]
                    (let [name (:series-name series-item)
                          data (:data series-item)
                          graph-type (:graph-type series-item)
                          dotted-line? (= graph-type "dotted line")
                          y-axis-id (:y-axis-id series-item)
                          graph-index (:graph-index series-item)
                          color (:color-code series-item)
                          tooltip-decimals (:tooltip-decimals series-item)
                          datalabel-decimals (:label-decimals series-item)
                          datalabel-multiplier (:label-multiplier series-item)
                          top-stack-only-label? (:top-stack-only-label? props)]
                      {:name         name
                       :type         (if dotted-line?
                                       "line"
                                       graph-type)
                       :yAxis        (dec y-axis-id)
                       :data         data
                       :stack        graph-index
                       :states       {:hover {:color (theme/color [:lp-report :chart :series-hover :bg])}}
                       :marker {:enabled false}
                       :borderWidth 0
                       :borderColor "transparent"
                       :dashStyle (when dotted-line? "Dot")
                       :color        (if (cu/blank-value? color)
                                       (theme/color [:lp-report :chart :multi-chart :ordered-default-colors
                                                     (keyword (str "color-" (inc index)))])
                                       color)
                       :dataLabels   {:enabled       (and (not (cu/blank-value? datalabel-decimals))
                                                          (not (cu/blank-value? datalabel-multiplier)))
                                      :formatter     (fn []
                                                       (this-as js-data-point
                                                                (let [value (.-y js-data-point)
                                                                      point-x (int (.-x js-data-point))
                                                                      stack-y (.-stackY js-data-point)
                                                                      total (.-total js-data-point)
                                                                      top-of-stack? (and (number? stack-y)
                                                                                         (number? total)
                                                                                         (= stack-y total))
                                                                      non-zero-value-count
                                                                      (->> (:series chart-data)
                                                                           (keep (fn [chart-series]
                                                                                   (let [series-value (get (:data chart-series)
                                                                                                           point-x)]
                                                                                     (when (and (number? series-value)
                                                                                                (not (zero? series-value)))
                                                                                       series-value))))
                                                                           count)
                                                                      show-label?
                                                                      (and (number? value)
                                                                           (not (zero? value))
                                                                           (or (not top-stack-only-label?)
                                                                               (> non-zero-value-count 1)
                                                                               top-of-stack?))
                                                                      suffix (case datalabel-multiplier
                                                                               1 ""
                                                                               1000 "k"
                                                                               1000000 "M"
                                                                               "")]
                                                                  (when show-label?
                                                                    (chart-utils/generic-label-formatter
                                                                     js-data-point
                                                                     datalabel-multiplier
                                                                     datalabel-decimals
                                                                     (if (= datalabel-multiplier
                                                                            (:y-axis-multiplier
                                                                             (nth (:y-axis-configs chart-data)
                                                                                  (dec y-axis-id))))
                                                                       ""
                                                                       suffix))))))
                                      :inside        true
                                      :style         {:fontSize    "0.8em"
                                                      :fontWeight "normal"
                                                      :textOutline false}}
                       :tooltip      {:pointFormatter (fn []
                                                        (this-as js-data-point
                                                                 (chart-utils/float-tooltip-formatter-dynamic-decimals
                                                                  js-data-point
                                                                  ""
                                                                  1
                                                                  tooltip-decimals)))}})))
                 (vec))
         series-categories (:series-categories chart-data)]
     {:chart       {:marginTop 40
                    :spacingRight 15
                    :style {:fontSize "16px"}}
      :plotOptions {:column {:stacking "normal"}
                    :series {:lineWidth (or custom-linewidth 3)}}
      :tooltip     {:shared true}
      :legend      {:enabled       true
                    :squareSymbol  false
                    :symbolWidth   35
                    :symbolHeight  8
                    :symbolRadius  5
                    :verticalAlign "top"
                    :align         "left"
                    :floating      true
                    :padding       0
                    :y             -7
                    :itemStyle     {:fontWeight "normal"}}
      :yAxis       y-axis-configs
      :xAxis       [{:categories series-categories
                     :lineColor  (theme/color [:lp-report :chart :x-axis :line])}]
      :annotations (when custom-annotation custom-annotation)
      :series      series})))
